import React, { useState } from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import './layout.scss';
import NoRouteFound from '../404/404.view';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import FAQ from '../faq/faq';
import OrderDetail from '../order-detail/order-detail';
import CardDetail from '../card-detail/card-detail';
import PrintCard from '../card-detail/print-card';

function Layout({ history }: RouteComponentProps) {
    const { pathname } = history.location;
    const isPrintPage = pathname === '/print';
    const [loading, setLoading] = useState(true);

    return (
        <Container fluid className="h-100 overflow-hidden">
            {!isPrintPage && <Header />}
            <Row
                className={`layout ${isPrintPage ? 'no-header' : ''} ${
                    !loading ? 'd-flex' : 'd-none'
                }`}
            >
                <Col className="content">
                    <Switch>
                        <Route
                            path="/faq"
                            exact
                            render={(props) => <FAQ {...props} setLoading={setLoading} />}
                        />
                        <Route
                            path="/sender/:orderno"
                            exact
                            render={(props) => <OrderDetail {...props} setLoading={setLoading} />}
                        />
                        <Route
                            exact
                            path="/cardid/:carddetid/itemid/:clientcardsrno/claim"
                            render={(props) => <CardDetail {...props} setLoading={setLoading} />}
                        />
                        <Route path="/print" exact render={(props) => <PrintCard {...props} />} />
                        <Route render={(props) => <NoRouteFound {...props} />} />
                    </Switch>
                    {!isPrintPage && <Footer history={history} />}
                </Col>
            </Row>
        </Container>
    );
}

export default withRouter(Layout);
